import { ShopPostStatus } from "../enums/ShopPostStatus";
import { Media } from "./Media";
import { PlannedPost } from "./PlannedPost";


export interface DetailedPlannedPost extends PlannedPost {
  media: Media[];
  media_ids: string[];
  status: ShopPostStatus;
}
